import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleLeft,
  faAngleRight
} from '@fortawesome/free-solid-svg-icons';

import { invoicesPath } from '../../../utilities/UrlPaths';

const ExistingPaging = ({
  totalGroups,
  startRowIndex,
  currentPage,
  urlDateString,
  endRowIndex,
}) => (
  <div className="text-right">
    <span className="text-right">
      {startRowIndex > 0 && (
      <a href={`${invoicesPath}/ExistingInvoices?page=${parseInt(currentPage, 10) - 1}${urlDateString}`}>
        <FontAwesomeIcon icon={faAngleLeft} /> Previous
      </a>
      )}
    </span>
    <span className="text-center pl-2 pr-2">
      {startRowIndex + 1}-{Math.min(endRowIndex, totalGroups)} of {totalGroups}
    </span>
    <span>
      {totalGroups > endRowIndex && (
      <a href={`${invoicesPath}/ExistingInvoices?page=${parseInt(currentPage, 10) + 1}${urlDateString}`}>
        Next <FontAwesomeIcon icon={faAngleRight} />
      </a>
      )}
    </span>
  </div>
);

export default ExistingPaging;
